import React, { useState, useRef, useContext, useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import { getAuth, signOut } from 'firebase/auth';
import './DashboardHeader.css';
import QRCode from 'react-qr-code';
import { useFont } from '../Design/FontContext';
import { ref, onValue } from 'firebase/database';
import { getDatabase } from 'firebase/database';
import { UnreadStatusContext } from '../Pages/Chats/UnreadStatusContext';
import CheckoutButton from '../Checkout/CheckoutButton';
import BottomPurchase from '../Pages/BottomPurchase';
import PerformanceMonitor from './PerformanceMonitor';

function DashboardHeader() {
    const auth = getAuth();
    const unreadStatus = useContext(UnreadStatusContext);
    const hasUnreadMessages = Object.values(unreadStatus).some(status => status);
    const userId = auth.currentUser ? auth.currentUser.uid : null;
    const [hasSalesGod, setHasSalesGod] = useState(false);
    const [showProfileMenu, setShowProfileMenu] = useState(false);
    const [qrDataUrl, setQrDataUrl] = useState(null);
    const qrRef = useRef(null);
    const profileMenuRef = useRef(null);
    const profilePicRef = useRef(null);
    const [showModal, setShowModal] = useState(false);
    const modalContentRef = useRef(null);
    const [hasSettings, setHasSettings] = useState(false);
    const [userPhoto, setUserPhoto] = useState('');
    const [isPremium, setIsPremium] = useState(false);
    const [currentOption, setCurrentOption] = useState('bonusClubLink');
    const [userName, setUserName] = useState('');
    const [userEmail, setUserEmail] = useState('');
    const selectedFont = useFont();
    const database = getDatabase();
    const [databaseName, setDatabaseName] = useState('');
    const priceId = 'price_1PMNWtEK7wspITU4nz2nByIH'; // Definiere hier deine Stripe Price ID

    const handleOptionChange = (option) => {
        setCurrentOption(option);
    };

    useEffect(() => {
        if (auth.currentUser) {
            setUserEmail(auth.currentUser.email || 'No Email');
        }
    }, [auth.currentUser]);

    useEffect(() => {
        if (userId) {
            const userNameRef = ref(database, `Users/${userId}/userName`);
            onValue(userNameRef, (snapshot) => {
                if (snapshot.exists()) {
                    setDatabaseName(snapshot.val());
                }
            });
        }
    }, [userId, database]);

    useEffect(() => {
        if (databaseName) {
            setUserName(databaseName);
        } else if (auth.currentUser && auth.currentUser.displayName) {
            setUserName(auth.currentUser.displayName);
        } else {
            setUserName('No Name');
        }
    }, [databaseName, auth.currentUser]);

    const getUrl = () => {
        return currentOption === 'bonusClubLink'
            ? `bonusclub.link/survey/${userId}`
            : `bonusclub.link/news/${userId}`;
    };

    const handleSignOut = () => {
        signOut(auth).then(() => {
            console.log("Erfolgreich abgemeldet!");
        }).catch((error) => {
            console.error("Fehler beim Abmelden:", error);
        });
    };

    const toggleProfileMenu = () => {
        setShowProfileMenu(prev => !prev);
    };

    useEffect(() => {
        const checkClickOutside = (e) => {
            if (showProfileMenu && profileMenuRef.current && !profileMenuRef.current.contains(e.target) && !profilePicRef.current.contains(e.target)) {
                toggleProfileMenu();
            }
        };

        document.addEventListener("mousedown", checkClickOutside);

        return () => {
            document.removeEventListener("mousedown", checkClickOutside);
        };
    }, [showProfileMenu]);

    const handleModalOpen = (e) => {
        e.preventDefault();
        setShowModal(true);
    };

    const handleModalClose = () => {
        setShowModal(false);
    };

    useEffect(() => {
        if (userId) {
            const userPhotoRef = ref(database, `Users/${userId}/userPhoto`);
            onValue(userPhotoRef, (snapshot) => {
                if (snapshot.exists()) {
                    setUserPhoto(snapshot.val());
                } else {
                    setUserPhoto('');
                }
            });
        }
    }, [userId, database]);

    useEffect(() => {
        const checkClickOutside = (e) => {
            if (showModal && modalContentRef.current && !modalContentRef.current.contains(e.target)) {
                handleModalClose();
            }
        };
        document.addEventListener("mousedown", checkClickOutside);

        return () => {
            document.removeEventListener("mousedown", checkClickOutside);
        };
    }, [showModal]);

    useEffect(() => {
        if (userId) {
            const userSettingsRef = ref(database, `Users/${userId}/hasSettings`);
            const listener = onValue(userSettingsRef, snapshot => {
                if (snapshot.exists()) {
                    setHasSettings(snapshot.val());
                }
            });
            // `listener` ist hier die Unsubscribe-Funktion aus `onValue`,
            // direkt aufrufen statt off(...) (das würde nichts detachen).
            return () => {
                listener();
            };
        }
    }, [userId]);

    useEffect(() => {
        if (userId) {
            const userSalesGodRef = ref(database, `Users/${userId}/hasSalesGod`);
            const salesGodListener = onValue(userSalesGodRef, snapshot => {
                if (snapshot.exists()) {
                    setHasSalesGod(snapshot.val());
                } else {
                    setHasSalesGod(false);
                }
            });
            return () => {
                salesGodListener();
            };
        }
    }, [userId, database]);

    const getButtonClass = (option) => {
        return currentOption === option ? 'button-active' : 'button-inactive';
    };

    useEffect(() => {
        if (userId) {
            const userPremiumRef = ref(database, `Users/${userId}/isPremium`);
            onValue(userPremiumRef, (snapshot) => {
                if (snapshot.exists()) {
                    setIsPremium(snapshot.val());
                } else {
                    setIsPremium(false);
                }
            });
        }
    }, [userId, database]);

    useEffect(() => {
        if (auth.currentUser) {
            setUserName(auth.currentUser.displayName || 'No Name');
            setUserEmail(auth.currentUser.email || 'No Email');
        }
    }, [auth.currentUser]);

    return (
        <div className="dashboard-header">
            {/* <PerformanceMonitor /> */}
            <div className="logo-and-menu">
                <NavLink to="/" style={{ textDecoration: 'none'}}>
                    <div  style={{ fontFamily: selectedFont }} className="header_logo_1"> <img src="/img/BonusClub_Logo.webp" alt="" /></div>
                </NavLink>
            </div>
            <div className="dashboard_header_links">
                <NavLink 
                    to={`/pages`} 
                    className={({ isActive }) => 
                    isActive ? "menu-item selector" : "menu-item"
                }
                >
                    <div>
                        <img className="invisible_icon" src="/img/bag.svg" alt=""/>
                        <p>Sales Pages</p> 
                    </div>
                </NavLink> 
      
                {/* <NavLink 
                    to={`/agency`} 
                    className={({ isActive }) => 
                        isActive ? "menu-item selector" : "menu-item"
                    }
                >
                    <div style={{ position: 'relative' }}>
                        <img className="invisible_icon" src="/img/brain.svg" alt="" />
                        <p className={hasUnreadMessages ? "unread-notification" : "no-unread-messages"}>1</p>
                        <p>Agency</p> 
                    </div>
                </NavLink> */}
                 
                 
                 <NavLink 
                     to={`/sales`} 
                     className={({ isActive }) => 
                     isActive ? "menu-item selector" : "menu-item"
                 }>
                     <div>
                         <img className="invisible_icon" src="/img/spark.svg" alt="" />
                         <p>Offers</p> 
                     </div>
                 </NavLink>
                 
                 <NavLink 
                     to={`/emailflow`} 
                     className={({ isActive }) => 
                     isActive ? "menu-item selector" : "menu-item"
                 }>
                     <div>
                         <img className="invisible_icon" src="/img/mail_2.svg" alt="" />
                         <p>Flows</p> 
                     </div>
                 </NavLink>
            </div>

            <div className="profile-section">
                <NavLink to="/user-settings" className="header-settings-icon" title="Settings">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <circle cx="12" cy="12" r="3"></circle>
                        <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"></path>
                    </svg>
                </NavLink>
                
                <div className="profile-section-wrapper" onClick={toggleProfileMenu}>
                <img 
                  src="/img/menu_1.svg" 
                  alt="Profilbild" 
                  className={`profile-pic-2 ${showProfileMenu ? 'profile-pic-rotate' : ''}`}
                  ref={profilePicRef} 
                />
                 <img 
                      src={userPhoto || "/img/user-three.svg"} // Verwenden des Benutzerfotos oder des Avatar-Bildes
                      alt="Profilbild" 
                      className="profile-pic"
                      ref={profilePicRef} 
                    />
               {showProfileMenu && (
    <div className="profile-menu" ref={profileMenuRef}>
        <div className="profile-menu-info">
           <div className="profile-menu-item-2" style={{color: 'black'}}>{userName}</div>
                    <div className="profile-menu-item-3" style={{color: 'black'}}>{userEmail}</div>
                    </div>
        {isPremium && (
            <div className="question-right-pro-6" style={{right: '135px', top: '8px'}}>
                <img className="crown" src="/img/crow.svg" alt="Pro"/>
                <p>PRO</p>
            </div>
        )}
            
                                        <div className="dashboard-menu-slice">
<img src="/img/edit.svg" alt= "link settings" />
<NavLink to="/user-settings">Edit Profile</NavLink>

</div>

<div className="dashboard-menu-slice" style={{marginTop: '-5px'}}>
<img src="/img/mailbox.svg" alt= "link settings" />
<a href="https://bonusclub.io" target="_blank">Contact Us</a>
</div>



<NavLink className="sign_out" to="/login" onClick={handleSignOut}>Sign Out</NavLink>
                    </div>
                )}
            </div>
            </div>
            {showModal && (
    <div className="modal">
        <div className="modal-content" ref={modalContentRef}>
            <div className="modal-switch">
                <button
                    onClick={() => setCurrentOption('bonusClubLink')}
                    className={getButtonClass('bonusClubLink')}
                >
                    Bonus Club
                </button>
                <button
                    onClick={() => setCurrentOption('newsletterWizard')}
                    className={getButtonClass('newsletterWizard')}
                >
                    Newsletter Wizard
                </button>
            </div>

            {currentOption === 'bonusClubLink' && (
                <>
                    <h2>Your QR Code</h2>
                    <QRCode className="modal-qr-code" value={getUrl()} ref={qrRef} />
                    <div className="modal-link-container">
                        <input type="text" value={getUrl()} readOnly />
                        <button onClick={() => navigator.clipboard.writeText(getUrl())}>
                            <img className="copy-link-img" src="/img/link.svg" alt="copy"/>
                        </button>
                    </div>
                       <div className="qr-buttons">
            <NavLink 
    to={`/survey/${userId}`}
    target="_blank"
    rel="noopener noreferrer"
    className="qr-modal-open"
>
    Open Club Link
</NavLink>
                <button className="qr-modal-close" onClick={handleModalClose}>Close</button>
            </div>
                </>
            )}

            {currentOption === 'newsletterWizard' && (
                <>
                    <h2>Your QR Code</h2>
                    <>
                            <QRCode className="modal-qr-code" value={getUrl()} ref={qrRef} />
                            <div className="modal-link-container">
                                <input type="text" value={getUrl()} readOnly />
                                <button onClick={() => navigator.clipboard.writeText(getUrl())}>
                                    <img className="copy-link-img" src="/img/link.svg" alt="copy"/>
                                </button>
                            </div>
                            <div className="qr-buttons">
            <NavLink 
    to={`/news/${userId}`}
    target="_blank"
    rel="noopener noreferrer"
    className="qr-modal-open"
>
    Open Newsletter Link
</NavLink>
                <button className="qr-modal-close" onClick={handleModalClose}>Close</button>
            </div>
                        </>
                    
                </>
            )}

         
        </div>
    </div>
)}


        </div>
    );
              }    
export default DashboardHeader;
